import { useEffect, useRef } from 'react';

import {
  PolygonDrawingCompleteHandler,
  PolygonDrawingController,
} from './PolygonDrawingController';

interface UsePolygonDrawingOptions {
  map?: google.maps.Map | null;
  isActive: boolean;
  polygonOptions?: google.maps.PolygonOptions;
  minVertices?: number;
  closeDistanceMeters?: number;
  // Re-arma el trazado tras cerrar un polígono (modo multi-polígono).
  reArmOnComplete?: boolean;
  onPolygonComplete: PolygonDrawingCompleteHandler;
}

export const usePolygonDrawing = ({
  map,
  isActive,
  polygonOptions,
  minVertices,
  closeDistanceMeters,
  reArmOnComplete = false,
  onPolygonComplete,
}: UsePolygonDrawingOptions): void => {
  const onCompleteRef = useRef(onPolygonComplete);

  onCompleteRef.current = onPolygonComplete;

  useEffect(() => {
    if (!map || !isActive) {
      return undefined;
    }

    const controller = new PolygonDrawingController(map, {
      polygonOptions,
      minVertices,
      closeDistanceMeters,
      onComplete: (polygon, path) => {
        onCompleteRef.current(polygon, path);

        // Permite seguir trazando polígonos sin volver a activar el modo.
        if (reArmOnComplete) {
          controller.start();
        }
      },
    });

    controller.start();

    return () => {
      controller.destroy();
    };
  }, [map, isActive, polygonOptions, minVertices, closeDistanceMeters, reArmOnComplete]);
};
